import React from 'react';
import PropTypes from 'prop-types';
import OptionButtons from './OptionButtons';
import PerksList from './PerksList';
import { Plans } from '../constants';
import { planDisclaimer } from './constants';

const MobileLayout = ({ handleChange, selected, onClickUpgrade }) => (
  <div className="trial-container">
    <div className="title-container">
      <h2>Start Today</h2>
      <h4>Pick your plan below</h4>
    </div>
    <OptionButtons
      handleChange={handleChange}
      selected={selected}
    />
    <PerksList selected={selected} />
    <p className="trial-notice mt-15 mb-9">
      {selected === Plans.ANNUAL ? planDisclaimer.ANNUAL : planDisclaimer.SEASONAL}
    </p>
    <div className="text-center w-90 margin-0-auto">
      <button
        type="button"
        className="btn btn-lg btn-cta"
        onClick={() => onClickUpgrade(selected)}
      >
        CONFIRM PURCHASE
      </button>
    </div>
    <p className="trial-notice my-15">
      *Additional $8/box shipping for Canada, Hawaii, Alaska, and
      Puerto Rico. Sales tax may apply (learn more).
    </p>
  </div>
);

MobileLayout.defaultProps = {
  handleChange: () => null,
  selected: Plans.SEASONAL,
};

MobileLayout.propTypes = {
  handleChange: PropTypes.func,
  selected: PropTypes.string,
};

export default MobileLayout;
